module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-1.bfc100e7.png";